import React from 'react';
import {connect} from 'react-redux';
import {push, replace} from 'react-router-redux';
import { injectIntl } from 'react-intl';
import './TipsDialog.scss';

const mapActionCreators = {
  push,
  replace,
};

const mapStateToProps = (state, ownProps) => {
  return {
    device: state.device.current
  }
};

class TipsDialog extends React.Component {
  state = {
  }

  componentWillMount() {
  }

  componentDidMount() {
  }

  componentWillUnmount(){
  }

  componentWillReceiveProps = (newProps) => {
  }


  render = () => {
    const { title, text, img, btn, textAlign, isRecommend, hideClose, onConfirm, onDismiss, device } = this.props;
    let showClose = hideClose === undefined || !hideClose;
    let extraStyle = textAlign === 'center' ? { alignSelf: 'center', textAlign: 'center' } : {};
    const pc = device === 'pc';
    return <>
      <div className="dialog_tips_container">
        <div className='dialog_tips_bg' 
          style={{width: pc ? '6.6rem' : '5.5rem'}}>
          {isRecommend && <div className='dialog_tips_recommend_flag'></div>}
          <div className='dialog_tips_title' style={extraStyle}>{title}</div>
          <div className='dialog_tips_desc' style={extraStyle}>
            {text}
            <br/>
            {!!img && <img alt='' className='dialog_tips_img' src={img} onClick={() => this.setState({showPreview: true})}/>}
          </div>
          <div className='dialog_tips_btn' onClick={onConfirm || onDismiss}>{btn || '知道了'}</div>
          {showClose && <div className='dialog_tips_close' onClick={onDismiss}></div>}
        </div>
      </div>
    </>
  }
}

export default connect(mapStateToProps, mapActionCreators)(injectIntl(TipsDialog));
